import PropTypes from 'prop-types'
import { Stack, StackItem } from '@astryxdesign/core/Stack'
import { Text } from '@astryxdesign/core/Text'
import { Token } from '@astryxdesign/core/Token'
import { Search } from './CreateGameDialog'
import { listMembers } from './consoleApi'
import { assigneeOf, memberName, personRoles, pickableMembers } from './consoleText'

// "Intervenants": the club members working on a block - the coach of an
// event, the employee doing the maintenance (azure-zephyr-2). Picked from the
// club's roster by name, any member, account or not; shown as tokens that
// can be taken out again. The server checks every one is a member.
export const ASSIGNEES_MAX = 20

// The colour of the member's role, Personnel first: that is who is usually
// put on a block.
function tokenColor(assignee) {
    const roles = personRoles(assignee)
    return roles.length > 0 ? roles[roles.length - 1].color : 'default'
}

export default function AssigneePicker({ clubId, value, onChange, onSessionLost }) {
    const picked = new Set(value.map(a => a.club_user_id))
    const isFull = value.length >= ASSIGNEES_MAX

    return (
        <Stack gap={2}>
            <Stack gap={0.5}>
                <Text weight="semibold">Intervenants</Text>
                <Text type="supporting" color="secondary">
                    Facultatif. Les adhérents qui travaillent sur ce créneau : comptés dans l&apos;onglet Occupation.
                </Text>
            </Stack>
            {value.length > 0 && (
                <Stack direction="horizontal" gap={1} wrap="wrap">
                    {value.map(a => (
                        <StackItem key={a.club_user_id} size="static">
                            <Token
                                label={a.name}
                                color={tokenColor(a)}
                                onRemove={() => onChange(value.filter(v => v.club_user_id !== a.club_user_id))}
                            />
                        </StackItem>
                    ))}
                </Stack>
            )}
            {isFull ? (
                <Text type="supporting" color="secondary">{`${ASSIGNEES_MAX} intervenants au plus.`}</Text>
            ) : (
                <Search
                    label="Ajouter un intervenant"
                    placeholder="Nom de l'adhérent"
                    find={async query => {
                        const answer = await listMembers(clubId, query)
                        return answer.status === 200 && answer.json
                            ? { status: 200, list: pickableMembers(answer.json.list || []) }
                            : { status: answer.status }
                    }}
                    toItem={m => ({
                        key: m.id,
                        label: memberName(m),
                        description: personRoles(m).map(r => r.label).join(' · ') || 'Adhérent',
                        isDisabled: picked.has(m.id),
                        onPick: () => onChange([...value, assigneeOf(m)]),
                    })}
                    emptyText="Aucun adhérent ne correspond."
                    takenText="Déjà intervenant"
                    hasAutoFocus={false}
                    onSessionLost={onSessionLost}
                />
            )}
        </Stack>
    )
}

AssigneePicker.propTypes = {
    clubId: PropTypes.string.isRequired,
    // { club_user_id, name, is_coach, is_admin, is_staff }
    value: PropTypes.arrayOf(PropTypes.shape({
        club_user_id: PropTypes.string.isRequired,
        name: PropTypes.string,
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    onSessionLost: PropTypes.func.isRequired,
}
